import React, {FC} from 'react';
import {ComponentResolver} from 'components/ContentPagesComponents/_ComponentResolver';
import {domToReact} from 'html-react-parser';
import {parseDocument} from 'htmlparser2';

export interface IStringToDomParserProps {
    xml: string,
}

const StringToDomParser: FC<IStringToDomParserProps> = ({xml}) => {
	return (
		<>
			{domToReact(
				parseDocument(xml, {xmlMode: true}).children,
				{
					trim: true,
					replace: ComponentResolver
				},
			)}
		</>
	);

};

export default StringToDomParser;
